import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledPublishId = Brand<number, 'ScheduledPublishId'>;
export const ScheduledPublishId = createBranded<ScheduledPublishId>();
